/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyInfoVo
 */
export interface CompanyInfoVo {
    /**
     * 公司信息id
     * @type {number}
     * @memberof CompanyInfoVo
     */
    id?: number;
    /**
     * 用户id
     * @type {number}
     * @memberof CompanyInfoVo
     */
    userId?: number;
    /**
     * 营业执照号
     * @type {string}
     * @memberof CompanyInfoVo
     */
    businessLicenseNumber?: string;
    /**
     * 商户名
     * @type {string}
     * @memberof CompanyInfoVo
     */
    merchantName?: string;
    /**
     * 邮箱
     * @type {string}
     * @memberof CompanyInfoVo
     */
    email?: string;
    /**
     * 营业执照文件url
     * @type {string}
     * @memberof CompanyInfoVo
     */
    businessLicenseFile?: string;
    /**
     * 排序
     * @type {number}
     * @memberof CompanyInfoVo
     */
    sort?: number;
    /**
     * 国家id
     * @type {number}
     * @memberof CompanyInfoVo
     */
    nationId?: number;
    /**
     * 电话号码
     * @type {string}
     * @memberof CompanyInfoVo
     */
    mobileNo?: string;
    /**
     * 企业营业执照地址
     * @type {string}
     * @memberof CompanyInfoVo
     */
    businessLicenseAddress?: string;
    /**
     * ctms号
     * @type {string}
     * @memberof CompanyInfoVo
     */
    ctmsNo?: string;
    /**
     * 商户名英文
     * @type {string}
     * @memberof CompanyInfoVo
     */
    merchantNameEn?: string;
    /**
     * 企业法人
     * @type {string}
     * @memberof CompanyInfoVo
     */
    legalRepresentative?: string;
    /**
     * 删除状态
     * @type {number}
     * @memberof CompanyInfoVo
     */
    deleteStatus?: number;
}

/**
 * Check if a given object implements the CompanyInfoVo interface.
 */
export function instanceOfCompanyInfoVo(value: object): value is CompanyInfoVo {
    return true;
}

export function CompanyInfoVoFromJSON(json: any): CompanyInfoVo {
    return CompanyInfoVoFromJSONTyped(json, false);
}

export function CompanyInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'businessLicenseNumber': json['businessLicenseNumber'] == null ? undefined : json['businessLicenseNumber'],
        'merchantName': json['merchantName'] == null ? undefined : json['merchantName'],
        'email': json['email'] == null ? undefined : json['email'],
        'businessLicenseFile': json['businessLicenseFile'] == null ? undefined : json['businessLicenseFile'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'businessLicenseAddress': json['businessLicenseAddress'] == null ? undefined : json['businessLicenseAddress'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'merchantNameEn': json['merchantNameEn'] == null ? undefined : json['merchantNameEn'],
        'legalRepresentative': json['legalRepresentative'] == null ? undefined : json['legalRepresentative'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
    };
}

export function CompanyInfoVoToJSON(json: any): CompanyInfoVo {
    return CompanyInfoVoToJSONTyped(json, false);
}

export function CompanyInfoVoToJSONTyped(value?: CompanyInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'businessLicenseNumber': value['businessLicenseNumber'],
        'merchantName': value['merchantName'],
        'email': value['email'],
        'businessLicenseFile': value['businessLicenseFile'],
        'sort': value['sort'],
        'nationId': value['nationId'],
        'mobileNo': value['mobileNo'],
        'businessLicenseAddress': value['businessLicenseAddress'],
        'ctmsNo': value['ctmsNo'],
        'merchantNameEn': value['merchantNameEn'],
        'legalRepresentative': value['legalRepresentative'],
        'deleteStatus': value['deleteStatus'],
    };
}

